import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingSpinner from './LoadingSpinner';
import Listino from './Listino';

const ListinoWrapper = () => {
  const { user, loading: authLoading } = useAuth();
  const location = useLocation();
  const [isPublic, setIsPublic] = useState(null);
  const [checkingVisibility, setCheckingVisibility] = useState(true);

  useEffect(() => {
    checkListinoVisibility();
  }, []);

  const checkListinoVisibility = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/listino-visibility`
      );
      
      if (response.ok) {
        const data = await response.json();
        setIsPublic(data.is_public);
      } else {
        // Default: richiede login se errore
        setIsPublic(false);
      }
    } catch (error) {
      console.error('Errore controllo visibilità listino:', error);
      // Default: richiede login se errore
      setIsPublic(false);
    } finally {
      setCheckingVisibility(false);
    }
  };

  // Mostra loading mentre controlla visibilità e auth
  if (checkingVisibility || authLoading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <LoadingSpinner message="Caricamento..." />
      </div>
    );
  }

  // Se il listino è pubblico, mostra direttamente
  if (isPublic) {
    return <Listino />;
  }

  // Se il listino è privato, controlla se l'utente è loggato
  if (!user) {
    // Redirect to login with return location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Utente loggato e listino privato -> mostra listino
  return <Listino />;
};

export default ListinoWrapper;
